import { EventTypeEnum } from '../enums';

export interface DeviceEventsWithDevicesInputDto {
    from: string;
    to: string;
    eventType?: EventTypeEnum | EventTypeEnum[];
    deviceIds: string | string[];
}
